import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

export type Organization = {
  _id: string;
  abbreviation: string;
  title: string;
  effectiveFrom: string;
  effectiveTo: string;
  school: string;
  isActive: boolean;
  dean?: Staff;
  frcChair?: Staff;
  frcSecretaries?: Staff[];
  departments?: Department[];
};

export type Department = {
  id: string;
  abbreviation: string;
  title: string;
  effectiveFrom: string;
  effectiveTo: string;
  school: string;
  isActive: boolean;
  head?: Staff;
  drcChair?: Staff;
  drcSecretaries?: Staff[];
};

type Staff = {
  netId: string;
  email: string;
  surname: string;
  givenName: string;
  title: string;
  department: string;
  effectiveFrom: string;
  effectiveTo: string;
};

type UseGetAllOrganizationsResult = {
  data: { getAllOrganizations: Organization[] } | undefined;
  loading: boolean;
  error: Error | undefined;
  refetch: () => void;
};

const GET_ALL_ORGANIZATIONS = gql`
  query GetAllOrganizations {
    getAllOrganizations {
      _id
      abbreviation
      title
      effectiveFrom
      effectiveTo
      school
      isActive
      dean {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
      frcChair {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
      frcSecretaries {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
      departments {
        id
        abbreviation
        title
        effectiveFrom
        effectiveTo
        school
        isActive
        head {
          netId
          email
          surname
          givenName
          title
          department
          effectiveFrom
          effectiveTo
        }
        drcChair {
          netId
          email
          surname
          givenName
          title
          department
          effectiveFrom
          effectiveTo
        }
        drcSecretaries {
          netId
          email
          surname
          givenName
          title
          department
          effectiveFrom
          effectiveTo
        }
      }
    }
  }
`;

export const useGetAllOrganizations = (): UseGetAllOrganizationsResult => {
  const { data, loading, error, refetch } = useQuery(GET_ALL_ORGANIZATIONS, {
    fetchPolicy: 'network-only',
  });

  return {
    data,
    loading,
    error,
    refetch,
  };
};
